import { useQuery } from "@tanstack/react-query";
import { getApiCodelistManagementFiles } from "Infrastructure/Api/Api";

export const CODELIST_FILES_QUERY_KEY = "CODELIST_FILES_QUERY";

export function useCodeListFilesQuery(
	folderPath?: string | null,
	isActive?: boolean | null
) {
	return useQuery({
		queryKey: [CODELIST_FILES_QUERY_KEY, folderPath, isActive],
		queryFn: () => getApiCodelistManagementFiles(folderPath, isActive),
	});
}
